import React, { useState } from "react";
import CalendarComponent from "./components/CalendarComponent.js";

function App() {
  const apartment1Url = "/.netlify/functions/apartment1";
  const apartment2Url = "/.netlify/functions/apartment2";

  return (
    <div className="app-container">
      <h1>Riva Klenovica - Booking Calendars</h1>
      <div className="calendars">
        <CalendarComponent
          title="Apartment 1 - 1st floor"
          icalUrl={apartment1Url}
        />
        <CalendarComponent
          title="Apartment 2 - ground floor"
          icalUrl={apartment2Url}
        />
      </div>
    </div>
  );
}

export default App;
